<template>
  <path d="M20.37,7.79H3.63V5H20.37Zm0,2.79H3.63v2.75H20.37Zm0,5.59H3.63V19H20.37Z" />
</template>

<script>
export default {
  name: 'Icon' + 'Menu'
};
</script>
